// import React, { useState, useEffect, useContext, useRef } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import CheckoutContext from "../contexts/CheckoutContext";
// import ProductShow from "../components/ProductShow";
// import Cart from "../components/Cart";
// import MainTitle from "../components/MainTitle";
// import LoadingSpinner from "../components/LoadingSpinner";
// import WaMeLink from "../components/WaMeLink";

// function ProductForm() {

//     const navigate = useNavigate();

//     const [products, setProducts] = useState([]);
//     const [cart, setCart] = useState([]);
//     const [isLoaded, setIsLoaded] = useState(false);
//     const [disabled, setDisabled] = useState(true);
//     const [discountAlertRendered, setDiscountAlertRendered] = useState(false);

//     const { items, setItems, setDeliveryDate, setDeliveryDirection, setClientData, setSeller } = useContext(CheckoutContext);
//     const containerRef = useRef(null);

// const scrollPeekRight = () => {
//         if (containerRef.current && products.length > 0) {
//             const lastIndex = products.length - 1;
//             if (containerRef.current.children[lastIndex]) {
//                 const item = containerRef.current.children[lastIndex];
//                 containerRef.current.scrollTo({
//                     left: item.offsetLeft,
//                     behavior: "smooth",
//                 });
//                 setTimeout(() => {
//                     containerRef.current.scrollTo({ left: 0, behavior: "smooth" });
//                 }, 800);
//             }
//         }
//     };

//     useEffect(() => {
//         async function getProducts() {
//             try {
//                 const response = await axios.get(`${process.env.REACT_APP_API_URL}product/active`);
//                 const data = response.data;

//                 await Promise.all(
//                     data
//                         .filter((p) => p.imageUrl)
//                         .map(
//                             (p) =>
//                                 new Promise((resolve) => {
//                                     const img = new Image();
//                                     img.onload = resolve;
//                                     img.onerror = resolve;
//                                     img.src = p.imageUrl;
//                                 })
//                         )
//                 );

//                 setProducts(data);
//                 setIsLoaded(true);
//             } catch (error) {
//                 console.log(error);
//             }
//         }
//         getProducts();
//     }, []);

//     useEffect(() => {
//         setItems([]);
//         setDeliveryDate([]);
//         setDeliveryDirection({});
//         setClientData({});
//         setSeller({});
//     }, []);

//     useEffect(() => {
//         let total_quantity = 0;
//         for (let i = 0; i < cart.length; i++) {
//             total_quantity += cart[i].quantity;
//         }
//         setDisabled(total_quantity < 1);
//     }, [cart]);

//     useEffect(() => {
//         if (containerRef.current && products.length > 0) {
//             scrollPeekRight();
//         }
//     }, [products]);

//     if (!isLoaded) {
//         return (
//             <div className="min-h-screen flex items-center justify-center bg-[#f7f4ef]">
//                 <LoadingSpinner />
//             </div>
//         );
//     }

//     return (
//         <div className="min-h-screen bg-[#f7f4ef]">

//             {/* Header de marca */}
//             <MainTitle />

//             {/* Strip informativo */}
//             <div className="mx-4 mt-4 mb-3 px-3 py-2.5 bg-white rounded-xl border border-gray-100 shadow-sm">
//                 <div className="flex flex-wrap justify-center gap-x-5 gap-y-1">
//                     <span className="flex items-center gap-1.5 text-[11px] text-gray-400">
//                         <svg className="w-3 h-3 text-[#3a5c3e] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                             <path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 0 1 16 0Z" /><circle cx="12" cy="10" r="3" />
//                         </svg>
//                         Cerro Navia · Renca · Pudahuel
//                     </span>
//                     <span className="flex items-center gap-1.5 text-[11px] text-gray-400">
//                         <svg className="w-3 h-3 text-[#3a5c3e] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                             <rect x="2" y="5" width="20" height="14" rx="2" /><line x1="2" y1="10" x2="22" y2="10" />
//                         </svg>
//                         Pago seguro — Mercado Pago
//                     </span>
//                 </div>
//             </div>

//             {/* Título sección productos */}
//             <div className="px-4 mb-1 flex items-center justify-between">
//                 <h2 className="text-[15px] font-semibold text-[#1a1f1a]">Elige tus productos</h2>
//                 {/* <span className="text-[11px] text-gray-400">desliza →</span> */}
//             </div>

//             {/* Wrapper con padding para que el ring/sombra de cards activas no se recorte */}
//             <div className="overflow-hidden">
//                 <div
//                     className="flex gap-3 px-4 py-3 overflow-x-auto"
//                     ref={containerRef}
//                     style={{
//                         scrollbarWidth: "none",
//                         msOverflowStyle: "none",
//                         WebkitOverflowScrolling: "touch",
//                     }}
//                 >
//                 {products.map((product, index) => (
//                     <div
//                         key={product.id}
//                         className="flex-shrink-0"
//                     >
//                         <ProductShow
//                             product={product}
//                             cart={cart}
//                             setCart={setCart}
//                             setItems={setItems}
//                             items={items}
//                         />
//                     </div>
//                 ))}
//                 </div>
//             </div>

//             {/* Separador */}
//             <div className="flex items-center gap-3 px-4 my-4">
//                 <div className="flex-1 h-px bg-gray-200" />
//                 <span className="text-[10px] text-gray-400 font-medium tracking-widest uppercase">tu pedido</span>
//                 <div className="flex-1 h-px bg-gray-200" />
//             </div>

//             {/* Carrito */}
//             <div className="pb-8">
//                 <Cart
//                     cart={cart}
//                     disabled={disabled}
//                     setDisabled={setDisabled}
//                     discountAlertRendered={discountAlertRendered}
//                     setDiscountAlertRendered={setDiscountAlertRendered}
//                 />
//             </div>

//             <WaMeLink />
//         </div>
//     );
// }

// export default ProductForm;


import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CheckoutContext from "../contexts/CheckoutContext";
import ProductShow from "../components/ProductShow";
import Cart from "../components/Cart";
import MainTitle from "../components/MainTitle";
import LoadingSpinner from "../components/LoadingSpinner";
import WaMeLink from "../components/WaMeLink";
import StepperBar from "../components/StepperBar";
import { trackViewContent, trackSearch } from "../pixel";

/* Emoji representativo según el nombre de la categoría */
function categoryIcon(name) {
    const n = (name || "").toLowerCase();
    if (n.includes("perr") || n.includes("dog") || n.includes("canin")) return "🐶";
    if (n.includes("gat") || n.includes("cat") || n.includes("felin")) return "🐱";
    if (n.includes("ave") || n.includes("pajar") || n.includes("pájar") || n.includes("bird")) return "🦜";
    if (n.includes("pez") || n.includes("peces") || n.includes("acuar")) return "🐠";
    if (n.includes("conej") || n.includes("roedor") || n.includes("hamster") || n.includes("hámster")) return "🐹";
    if (n.includes("juguete")) return "🎾";
    if (n.includes("higien") || n.includes("aseo") || n.includes("baño")) return "🧴";
    if (n.includes("cama") || n.includes("accesor") || n.includes("correa")) return "🦴";
    if (n.includes("alimento") || n.includes("comida") || n.includes("snack")) return "🍖";
    return "🐾";
}

const ALL = "Todos";

function ProductForm() {

    const navigate = useNavigate();

    const [products, setProducts] = useState([]);
    const [cart, setCart] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [discountAlertRendered, setDiscountAlertRendered] = useState(false);

    /* Búsqueda y filtro por categoría */
    const [search, setSearch] = useState("");
    const [activeCat, setActiveCat] = useState(ALL);
    const searchDebounceRef = useRef(null);

    const { items, setItems, setDeliveryDate, setDeliveryDirection, setClientData, setSeller } = useContext(CheckoutContext);

    useEffect(() => {
        async function getProducts() {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}product/active`);
                const data = response.data;

                await Promise.all(
                    data
                        .filter((p) => p.imageUrl)
                        .map(
                            (p) =>
                                new Promise((resolve) => {
                                    const img = new Image();
                                    img.onload = resolve;
                                    img.onerror = resolve;
                                    img.src = p.imageUrl;
                                })
                        )
                );

                setProducts(data);
                trackViewContent(data);
                setIsLoaded(true);
            } catch (error) {
                console.log(error);
            }
        }
        getProducts();
    }, []);

    useEffect(() => {
        setItems([]);
        setDeliveryDate([]);
        setDeliveryDirection({});
        setClientData({});
        setSeller({});
    }, []);

    useEffect(() => {
        let total_quantity = 0;
        for (let i = 0; i < cart.length; i++) {
            total_quantity += cart[i].quantity;
        }
        setDisabled(total_quantity < 1);
    }, [cart]);

    /* Lista de categorías a partir de los productos (si el backend las entrega) */
    const categories = useMemo(() => {
        const set = new Set(
            products.map((p) => p.category).filter((c) => c && String(c).trim() !== "")
        );
        return Array.from(set);
    }, [products]);

    /* Productos filtrados por búsqueda + categoría */
    const filtered = useMemo(() => {
        const q = search.trim().toLowerCase();
        return products.filter((p) => {
            const matchCat = activeCat === ALL || p.category === activeCat;
            const matchSearch =
                !q ||
                (p.name && p.name.toLowerCase().includes(q)) ||
                (p.description && p.description.toLowerCase().includes(q));
            return matchCat && matchSearch;
        });
    }, [products, search, activeCat]);

    /* Productos agrupados por categoría (para la vista "Todos" sin búsqueda) */
    const grouped = useMemo(() => {
        if (categories.length === 0) {
            return [{ name: "Nuestros productos", items: filtered }];
        }
        return categories
            .map((cat) => ({
                name: cat,
                items: filtered.filter((p) => p.category === cat),
            }))
            .filter((g) => g.items.length > 0);
    }, [categories, filtered]);

    const showGrouped = activeCat === ALL && search.trim() === "";

    if (!isLoaded) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#fdf7ef]">
                <LoadingSpinner />
            </div>
        );
    }

    /* Tarjeta de producto reutilizable */
    const renderProduct = (product) => (
        <ProductShow
            key={product.id}
            product={product}
            cart={cart}
            setCart={setCart}
            setItems={setItems}
            items={items}
        />
    );

    return (
        <div className="min-h-screen bg-[#fdf7ef]">

            {/* Header de marca */}
            <MainTitle />
            <StepperBar step={1} />

            {/* Hero de bienvenida */}
            <section className="relative overflow-hidden bg-gradient-to-br from-[#155e63] to-[#0f4a4e] px-5 py-6 sm:py-8">
                <div
                    className="absolute inset-0 opacity-[0.08] pointer-events-none"
                    style={{
                        backgroundImage:
                            "radial-gradient(circle at 15% 25%, #fff 3px, transparent 3px), radial-gradient(circle at 75% 60%, #fff 3px, transparent 3px), radial-gradient(circle at 45% 90%, #fff 3px, transparent 3px)",
                        backgroundSize: "90px 90px",
                    }}
                />
                <div className="relative max-w-2xl mx-auto text-center">
                    <h2
                        className="text-[20px] sm:text-[26px] font-extrabold text-[#fdf7ef] leading-tight"
                        style={{ fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}
                    >
                        Todo para consentir a tu mascota 🐾
                    </h2>
                    <p className="text-[12px] sm:text-[13px] text-[#bcd4d2] mt-1.5">
                        Comida, snacks, juguetes y accesorios — despacho a domicilio
                    </p>
                </div>
            </section>

            {/* Strip informativo */}
            <div className="mx-3 sm:mx-auto sm:max-w-2xl mt-4 mb-3 px-3 py-2.5 bg-white rounded-xl border border-gray-100 shadow-sm">
                <div className="flex flex-wrap justify-center gap-x-5 gap-y-1">
                    <span className="flex items-center gap-1.5 text-[11px] text-gray-500">
                        <svg className="w-3 h-3 text-[#f5853f] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 0 1 16 0Z" /><circle cx="12" cy="10" r="3" />
                        </svg>
                        Cerro Navia · Renca · Pudahuel
                    </span>
                    <span className="flex items-center gap-1.5 text-[11px] text-gray-500">
                        <svg className="w-3 h-3 text-[#f5853f] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="2" y="5" width="20" height="14" rx="2" /><line x1="2" y1="10" x2="22" y2="10" />
                        </svg>
                        Pago seguro — Mercado Pago
                    </span>
                </div>
            </div>

            {/* Buscador */}
            <div className="px-3 sm:px-0 sm:max-w-2xl sm:mx-auto mb-3">
                <div className="relative">
                    <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
                    </svg>
                    <input
                        type="text"
                        value={search}
                        onChange={(e) => {
                            const val = e.target.value;
                            setSearch(val);
                            clearTimeout(searchDebounceRef.current);
                            if (val.trim().length >= 2) {
                                searchDebounceRef.current = setTimeout(() => trackSearch(val.trim()), 600);
                            }
                        }}
                        placeholder="Buscar comida, juguetes, accesorios..."
                        className="w-full pl-9 pr-9 py-2.5 rounded-xl bg-white border border-gray-200 text-[13px] text-[#1d2b2a] placeholder:text-gray-400 outline-none focus:border-[#f5853f] focus:ring-2 focus:ring-[#f5853f]/20 transition"
                    />
                    {search && (
                        <button
                            onClick={() => setSearch("")}
                            className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center rounded-full bg-gray-100 text-gray-500 text-xs hover:bg-gray-200"
                            aria-label="Limpiar búsqueda"
                        >
                            ✕
                        </button>
                    )}
                </div>
            </div>

            {/* Filtro por categorías */}
            {categories.length > 0 && (
                <div className="sm:max-w-2xl sm:mx-auto mb-2">
                    <div
                        className="flex gap-2 px-3 sm:px-0 pb-1 overflow-x-auto"
                        style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
                    >
                        {[ALL, ...categories].map((cat) => {
                            const active = activeCat === cat;
                            return (
                                <button
                                    key={cat}
                                    onClick={() => setActiveCat(cat)}
                                    className={`
                                        flex-shrink-0 flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[12px] font-semibold
                                        transition-all duration-150
                                        ${active
                                            ? "bg-[#0f4a4e] text-[#fdf7ef] shadow-md"
                                            : "bg-white text-[#1d2b2a] border border-gray-200 hover:border-[#f5853f]"
                                        }
                                    `}
                                >
                                    <span>{cat === ALL ? "🐾" : categoryIcon(cat)}</span>
                                    {cat}
                                </button>
                            );
                        })}
                    </div>
                </div>
            )}

            {/* Listado de productos */}
            <div className="px-3 sm:px-0 sm:max-w-2xl sm:mx-auto">
                {filtered.length === 0 ? (
                    <div className="py-12 flex flex-col items-center text-center gap-2">
                        <span className="text-4xl">🐾</span>
                        <p className="text-sm text-gray-500 font-medium">No encontramos productos</p>
                        <p className="text-xs text-gray-400">Prueba con otra búsqueda o categoría</p>
                    </div>
                ) : showGrouped ? (
                    /* Vista agrupada por categoría */
                    grouped.map((group) => (
                        <div key={group.name} className="mb-6">
                            <div className="flex items-center gap-2 mb-2">
                                <span className="text-lg">{categoryIcon(group.name)}</span>
                                <h3 className="text-[15px] font-bold text-[#1d2b2a]">{group.name}</h3>
                                <span className="text-[11px] text-gray-400">({group.items.length})</span>
                            </div>
                            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 auto-rows-fr">
                                {group.items.map(renderProduct)}
                            </div>
                        </div>
                    ))
                ) : (
                    /* Vista filtrada (búsqueda o categoría específica) */
                    <div className="mb-6">
                        <div className="flex items-center justify-between mb-2">
                            <h3 className="text-[15px] font-bold text-[#1d2b2a]">
                                {activeCat === ALL ? "Resultados" : activeCat}
                            </h3>
                            <span className="text-[11px] text-gray-400">
                                {filtered.length} {filtered.length === 1 ? "producto" : "productos"}
                            </span>
                        </div>
                        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 auto-rows-fr">
                            {filtered.map(renderProduct)}
                        </div>
                    </div>
                )}
            </div>

            {/* Separador */}
            <div className="flex items-center gap-3 px-4 my-4 sm:max-w-2xl sm:mx-auto">
                <div className="flex-1 h-px bg-gray-200" />
                <span className="text-[10px] text-gray-400 font-medium tracking-widest uppercase">tu pedido</span>
                <div className="flex-1 h-px bg-gray-200" />
            </div>

            {/* Carrito */}
            <div className="pb-10">
                <Cart
                    cart={cart}
                    disabled={disabled}
                    setDisabled={setDisabled}
                    discountAlertRendered={discountAlertRendered}
                    setDiscountAlertRendered={setDiscountAlertRendered}
                />
            </div>

            <WaMeLink />
        </div>
    );
}

export default ProductForm;